import { ModuleContentTypes } from '../';
import type { IModule, IModuleData } from '../';
import { type INote, Note } from '../';
import { ALMResource, ALMResourceContentTypes } from '../';
import type { IALMResource } from '../';

export class Module implements IModule {
  id = '';
  courseId = '';
  instanceId = '';
  hasPassed = false;
  contentType: ModuleContentTypes = ModuleContentTypes.Content;
  moduleType = 'Elearning';
  progress = 0;
  durationInMinutes = 0;
  name = '';
  description = '';
  notes: INote[] = [];
  isSubmissible = false;
  mandatory = false;
  resources?: IALMResource[];

  constructor(data: IModuleData) {
    Object.assign(this, data);
    if (data.notes) this.notes.map((n) => new Note(n));
    if (data.resources) {
      this.resources = this.resources
        ?.map((r) => new ALMResource(r))
        .filter((item) => item.contentType != ALMResourceContentTypes.Other);
    }
  }

  validate(): void {
    throw new Error('Method not implemented.');
  }

  get isUploadable(): boolean {
    return this.isSubmissible;
  }
}
